import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pesquisaArea: '',
    pesquisaGrupo: '',
    pesquisaLivre: '',
    idReferencia: 0,
    cesta: null,
    mostrarPesquisa: true,
    numeroGrupos: 1,
  },
  mutations: {
    pesquisaAreaMudou(state, valor){
      state.pesquisaArea = valor
      state.pesquisaGrupo = ""
    },
    pesquisaGrupoMudou(state, valor){
      state.pesquisaGrupo = valor
    },
    pesquisaLivreMudou(state, valor){
      state.pesquisaLivre = valor
    },
    referenciaMudou(state, valor){
      state.idReferencia = valor
    },
    cestaMudou(state,valor){
      state.cesta = valor
    },
    mostrarPesquisaMudou(state,valor){
      state.mostrarPesquisa = valor
    },
    numeroGruposMudou(state,valor){
      state.numeroGrupos = valor
    }
  },
  actions: {
  },
  modules: {
  },
  getters:{
    pesquisaAreaRecuperar: state => state.pesquisaArea,
    pesquisaGrupoRecuperar: state => state.pesquisaGrupo,
    pesquisaLivreRecuperar: state => state.pesquisaLivre,
    referenciaRecuperar: state => state.idReferencia,
    cestaRecuperar: state => state.cesta,
    mostrarPesquisaRecuperar: state => state.mostrarPesquisa,
    numeroGruposRecuperar: state => state.numeroGrupos
    
  },
  plugins: [createPersistedState()],
})
